import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

export default function CountDownTimer(props) {

    var waitingTime = props.timer
    var [progress, setProgress] = useState(waitingTime * 60)
    var _progress = waitingTime * 60



    useEffect(() => {
        var interval = setInterval(() => {
            if (_progress > 2) {
                _progress = _progress - 1;
                // console.log(_progress)
                setProgress(_progress)
            } else {
                _progress = 0
                setProgress(_progress)
                clearInterval(interval)
                console.log('sss')
                props.finished()
            }


  

        }, 1000)
    }, [])



    return (
        <div style={{ width: 30, height: 30 }}>
            <div>
                <CircularProgressbar value={parseInt(progress % 60)} maxValue={60} text={`${parseInt(progress / 60) + 1}`}
                    styles={buildStyles({
                        // Rotation of path and trail, in number of turns (0-1)
                        // rotation: 0.25,

                        // Whether to use rounded or flat cornersparseInt on the ends - can use 'butt' or 'round'
                        // strokeLinecap: 'butt',

                        // Text size
                        textSize: '60px',

                        // How long animation takes to go from one percentage to another, in seconds
                        pathTransitionDuration: 0.5,

                        // Can specify path transition in more detail, or remove it entirely
                        pathTransition: 'none',

                        // Colors
                        pathColor: ` rgb(230, 230, 230)`,
                        textColor: '#000000',
                        trailColor: `rgb(0, 0, 0)`,

                    })}

                />

            </div>

        </div >
    )
}
